import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateVehicleonboard,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [additionalThings, setAdditionalThings] = useState([]);
  const [availableThings, setAvailableThings] = useState([]);
  const [selectedThing, setSelectedThing] = useState("");
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [newThingName, setNewThingName] = useState("");
  const [showNewThingInput, setShowNewThingInput] = useState(false);

  useEffect(() => {
    if (select_data) {
      setAdditionalThings(
        (select_data.additionalThings || []).map((item) => ({
          thing: typeof item.thing === "object" ? item.thing._id : item.thing,

          name: typeof item.thing === "object" ? item.thing.name : "",

          photo: null,
          photoUrl: item.photo || null,
        })),
      );
      setUpdate_modal_data({
        ...select_data,
        vehicle_type: select_data.vehicle_type
          ? select_data.vehicle_type._id
          : "",
        client: select_data.client ? select_data.client._id : "",
        handover_supervisor: select_data.handover_supervisor
          ? select_data.handover_supervisor._id
          : "",

        currentKm: select_data.currentKm ?? 0,
        serviceCompleted: select_data.serviceCompleted ?? false,
        lastServiceKm: select_data.lastServiceKm ?? 0,
        lastServiceDate: select_data.lastServiceDate
          ? select_data.lastServiceDate.split("T")[0]
          : "",
        lastServiceType: select_data.lastServiceType ?? "undefined",
      });
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  useEffect(() => {
    const fetchAdditionalThings = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v4/additional-things`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data?.success) {
          setAvailableThings(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching additional things:", error);
        setAvailableThings([]);
      }
    };

    fetchAdditionalThings();
  }, []);

  useEffect(() => {
    const fetchVehicleTypes = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-types`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data && response.data.vehicleType) {
          setVehicleTypes(response.data.vehicleType);
        } else {
          console.error("Unexpected response format:", response.data);
          setVehicleTypes([]);
        }
      } catch (error) {
        console.error("Error fetching vehicle types:", error);
        setVehicleTypes([]);
      }
    };

    fetchVehicleTypes();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUsers(response.data.users);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };
    fetchUsers();
  }, []);

  const handleUserChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      handover_supervisor: value,
    }));
  };

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setClients(response.data.clients);
      } catch (error) {
        console.error("Error fetching clients:", error);
        setClients([]);
      }
    };
    fetchClients();
  }, []);

  const handleClientChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      client: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "temp_number") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "date") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "vehicle_type") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "size") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "leasing_partner") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "location") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "client") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "handover_supervisor") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "currentKm") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "serviceCompleted") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "lastServiceKm") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "lastServiceDate") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else if (name === "comments") {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    } else {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    }
  };

  const validateFields = () => {
    const newErrors = {};
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAdditionalThingPhotoChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setSelectedPhoto(file);
    }
  };

  const handleAddAdditionalThing = async () => {
    if (!selectedThing) {
      Swal.fire("Please select an additional thing", "", "warning");
      return;
    }

    if (!selectedPhoto) {
      Swal.fire("Please upload a photo", "", "warning");
      return;
    }

    const thing = availableThings.find((item) => item._id === selectedThing);

    if (!thing) return;

    const alreadyExists = additionalThings.some(
      (item) => item.thing === selectedThing,
    );

    if (alreadyExists) {
      Swal.fire(
        "Already Added",
        `${thing.name} is already added to this vehicle.`,
        "warning",
      );
      return;
    }

    setAdditionalThings((prev) => [
      ...prev,
      {
        thing: thing._id,
        name: thing.name,
        photo: selectedPhoto,
        photoUrl: null,
      },
    ]);

    setSelectedThing("");
    setSelectedPhoto(null);

    const photoInput = document.getElementById("additionalThingPhotoInput");

    if (photoInput) {
      photoInput.value = "";
    }
  };

  const handleCreateNewThing = async () => {
    if (!newThingName.trim()) {
      Swal.fire("Please enter the additional thing name", "", "warning");
      return;
    }

    if (!selectedPhoto) {
      Swal.fire("Please upload a photo", "", "warning");
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v4/additional-things`,
        {
          name: newThingName.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const thing = response.data.data;

      setAvailableThings((prev) => {
        const exists = prev.some((item) => item._id === thing._id);

        return exists ? prev : [...prev, thing];
      });

      setAdditionalThings((prev) => [
        ...prev,
        {
          thing: thing._id,
          name: thing.name,
          photo: selectedPhoto,
          photoUrl: null,
        },
      ]);

      setNewThingName("");
      setSelectedPhoto(null);
      setShowNewThingInput(false);

      const photoInput = document.getElementById("additionalThingPhotoInput");

      if (photoInput) {
        photoInput.value = "";
      }
    } catch (error) {
      console.error("Error creating additional thing:", error);

      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to create additional thing",
        "error",
      );
    }
  };

  const handleRemoveAdditionalThing = (index) => {
    setAdditionalThings((prev) =>
      prev.filter((_, itemIndex) => itemIndex !== index),
    );
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          // Create a new FormData object
          // const formData = new FormData();
          // formData.append("temp_number", update_modal_data.temp_number);
          // formData.append("date", update_modal_data.date);
          // formData.append("vehicle_type", update_modal_data.vehicle_type);
          // formData.append("size", update_modal_data.size);
          // formData.append("leasing_partner", update_modal_data.leasing_partner);
          // formData.append("location", update_modal_data.location);
          // formData.append("client", update_modal_data.client);
          // formData.append("currentKm", update_modal_data.currentKm);
          // formData.append(
          //   "serviceCompleted",
          //   update_modal_data.serviceCompleted,
          // );
          // formData.append("lastServiceKm", update_modal_data.lastServiceKm);
          // formData.append(
          //   "lastServiceDate",
          //   update_modal_data.lastServiceDate || "",
          // );
          // formData.append("comments", update_modal_data.comments);
          // formData.append(
          //   "handover_supervisor",
          //   update_modal_data.handover_supervisor,
          // );

          // const updateData = {
          //   temp_number: update_modal_data.temp_number,
          //   date: update_modal_data.date,
          //   vehicle_type: update_modal_data.vehicle_type,
          //   size: update_modal_data.size,
          //   leasing_partner: update_modal_data.leasing_partner,
          //   location: update_modal_data.location,
          //   client: update_modal_data.client,
          //   currentKm: Number(update_modal_data.currentKm) || 0,
          //   serviceCompleted: Boolean(update_modal_data.serviceCompleted),
          //   lastServiceKm: Number(update_modal_data.lastServiceKm) || 0,
          //   lastServiceDate: update_modal_data.lastServiceDate
          //     ? update_modal_data.lastServiceDate
          //     : undefined,

          //   lastServiceType: update_modal_data.lastServiceType
          //     ? update_modal_data.lastServiceType
          //     : undefined,
          //   comments: update_modal_data.comments,
          //   handover_supervisor: update_modal_data.handover_supervisor,
          // };

          // // const res = await axios.put(
          // //   `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-onboarding/${_id}`,
          // //   formData,
          // //   {
          // //     headers: {
          // //       Authorization: `Bearer ${token}`,
          // //     },
          // //   },
          // // );

          const formData = new FormData();

          formData.append("temp_number", update_modal_data.temp_number || "");
          formData.append("date", update_modal_data.date || "");
          formData.append("vehicle_type", update_modal_data.vehicle_type || "");
          formData.append("size", update_modal_data.size || "");
          formData.append(
            "leasing_partner",
            update_modal_data.leasing_partner || "",
          );
          formData.append("location", update_modal_data.location || "");
          formData.append("client", update_modal_data.client || "");
          formData.append(
            "currentKm",
            Number(update_modal_data.currentKm) || 0,
          );
          formData.append(
            "serviceCompleted",
            Boolean(update_modal_data.serviceCompleted),
          );
          formData.append(
            "lastServiceKm",
            Number(update_modal_data.lastServiceKm) || 0,
          );
          formData.append(
            "lastServiceDate",
            update_modal_data.lastServiceDate || "",
          );
          formData.append(
            "lastServiceType",
            update_modal_data.lastServiceType || "",
          );
          formData.append("comments", update_modal_data.comments || "");
          formData.append(
            "handover_supervisor",
            update_modal_data.handover_supervisor || "",
          );

          // Additional Things
          let photoIndex = 0;

          const additionalThingsData = additionalThings.map((item) => {
            const data = {
              thing: item.thing,
              existingPhoto: item.photoUrl || null,
              photoIndex: null,
            };

            if (item.photo) {
              data.photoIndex = photoIndex;

              formData.append("additionalThingPhotos", item.photo);

              photoIndex++;
            }

            return data;
          });

          formData.append(
            "additionalThings",
            JSON.stringify(additionalThingsData),
          );

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-onboarding/${_id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            // onUpdateVehicleonboard(update_modal_data);
            onUpdateVehicleonboard(res.data.data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Vehicle Maintenance Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Number Plate </Form.Label>
              <Form.Control
                type="text"
                name="temp_number"
                value={update_modal_data.temp_number || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Vehicle Type</Form.Label>

              <Select
                name="vehicle_type"
                options={vehicleTypes.map((vehicle) => ({
                  value: vehicle._id,
                  label: `${vehicle.company || "N/A"} / ${vehicle.feet || 0}`,
                }))}
                value={
                  vehicleTypes
                    .map((vehicle) => ({
                      value: vehicle._id,
                      label: `${vehicle.company || "N/A"} / ${vehicle.feet || 0}`,
                    }))
                    .find(
                      (option) =>
                        option.value === update_modal_data.vehicle_type,
                    ) || null
                }
                onChange={(selectedOption) =>
                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    vehicle_type: selectedOption ? selectedOption.value : "",
                  }))
                }
                placeholder="Select Vehicle Type"
                isClearable
                classNamePrefix="select"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>On-Boarding Date</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={update_modal_data.date || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="client">
              <Form.Label>Assign Client *</Form.Label>
              <Form.Control
                as="select"
                name="client"
                value={update_modal_data.client || ""}
                onChange={handleClientChange}
                isInvalid={!!errors.client}
              >
                <option value="">Select Clients</option>
                {clients.map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.client}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Leasing Partner</Form.Label>
              <Form.Control
                type="text"
                name="leasing_partner"
                value={update_modal_data.leasing_partner || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Location (City) </Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={update_modal_data.location || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="handover_supervisor">
              <Form.Label>Handover Supervisor *</Form.Label>
              <Form.Control
                as="select"
                name="handover_supervisor"
                value={update_modal_data.handover_supervisor || ""}
                onChange={handleUserChange}
                isInvalid={!!errors.handover_supervisor}
              >
                <option value="">Select User</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.handover_supervisor}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Size </Form.Label>
              <Form.Control
                type="text"
                name="size"
                value={update_modal_data.size || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Current KM *</Form.Label>
              <Form.Control
                type="number"
                name="currentKm"
                min="0"
                value={update_modal_data.currentKm ?? 0}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Service Completed *</Form.Label>
              <Form.Control
                as="select"
                name="serviceCompleted"
                value={update_modal_data.serviceCompleted ? "true" : "false"}
                onChange={(e) =>
                  setUpdate_modal_data({
                    ...update_modal_data,
                    serviceCompleted: e.target.value === "true",
                  })
                }
              >
                <option value="false">No</option>
                <option value="true">Yes</option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Last Service KM</Form.Label>
              <Form.Control
                type="number"
                name="lastServiceKm"
                min="0"
                value={update_modal_data.lastServiceKm ?? 0}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Last Service Date</Form.Label>
              <Form.Control
                type="date"
                name="lastServiceDate"
                value={update_modal_data.lastServiceDate || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Last Service Type</Form.Label>

              <Form.Control
                as="select"
                name="lastServiceType"
                value={update_modal_data.lastServiceType || ""}
                onChange={handleChange}
              >
                <option value="">Select Service Type</option>
                <option value="First">First</option>
                <option value="Second">Second</option>
                <option value="Third">Third</option>
                <option value="Fixed">Fixed</option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Comments</Form.Label>
              <Form.Control
                type="text"
                name="comments"
                value={update_modal_data.comments || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Additional Things</Form.Label>

              {/* Select Existing Thing */}
              <div className="d-flex gap-2 mb-2">
                <Form.Control
                  as="select"
                  value={selectedThing}
                  onChange={(e) => setSelectedThing(e.target.value)}
                >
                  <option value="">Select Additional Thing</option>

                  {availableThings.map((thing) => (
                    <option key={thing._id} value={thing._id}>
                      {thing.name}
                    </option>
                  ))}
                </Form.Control>

                <Button
                  variant="outline-primary"
                  type="button"
                  onClick={() => setShowNewThingInput(true)}
                >
                  + Add New
                </Button>
              </div>

              {/* New Thing */}
              {showNewThingInput && (
                <div className="border rounded p-3 mb-3">
                  <Form.Label>New Additional Thing</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Enter thing name"
                    value={newThingName}
                    onChange={(e) => setNewThingName(e.target.value)}
                    className="mb-2"
                  />

                  <div className="d-flex gap-2">
                    <Button
                      variant="primary"
                      type="button"
                      onClick={handleCreateNewThing}
                    >
                      Add New Thing
                    </Button>

                    <Button
                      variant="secondary"
                      type="button"
                      onClick={() => {
                        setShowNewThingInput(false);
                        setNewThingName("");
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}

              {/* Photo */}
              <Form.Control
                id="additionalThingPhotoInput"
                type="file"
                accept="image/*"
                onChange={handleAdditionalThingPhotoChange}
                className="mb-2"
              />

              <Button
                variant="success"
                type="button"
                onClick={handleAddAdditionalThing}
              >
                Add Additional Thing
              </Button>

              {/* Existing + Newly Added Things */}
              {additionalThings.length > 0 && (
                <div className="mt-3">
                  {additionalThings.map((item, index) => (
                    <div
                      key={`${item.thing}-${index}`}
                      className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between"
                    >
                      <div className="d-flex align-items-center gap-3">
                        {/* Existing Photo */}
                        {item.photoUrl && (
                          <img
                            src={item.photoUrl}
                            alt={item.name}
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                              borderRadius: "6px",
                            }}
                          />
                        )}

                        {/* New Photo Preview */}
                        {item.photo && (
                          <img
                            src={URL.createObjectURL(item.photo)}
                            alt={item.name}
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                              borderRadius: "6px",
                            }}
                          />
                        )}

                        <div>
                          <strong>{item.name}</strong>

                          <div className="text-muted small">
                            {item.photo
                              ? item.photo.name
                              : item.photoUrl
                                ? "Existing Photo"
                                : "No Photo"}
                          </div>
                        </div>
                      </div>

                      <Button
                        variant="outline-danger"
                        size="sm"
                        type="button"
                        onClick={() => handleRemoveAdditionalThing(index)}
                      >
                        Remove
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Vehicle On-Board
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
